import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { pick, omit } from 'lodash';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { PngFlag } from '../common/pngFlag';
import { Circles } from '../common/loadingComponent';
import { writeErr } from '../common/logger';
import { getParams } from '../common/utils';
import { popupActions } from '../../store/popupStore';
import { layoutActions } from '../../store/layoutStore';
import { apiGet, getHostApi, hasPermission } from '../../store/apiWrapper';
import { repiActions, reportTypes, repiSearchFields, searchTypes, entityTypes } from '../../store/repiStore';
import { capitalize, isNullOrUndefined, isString,  isEmpty, removeDiacritics, getRepiSetting } from '../../store/storeFunctions';
import { addConsentToStorage, getReportsAvailability, hasConsentInStorage, isPoolReport, isValidDate } from './repiUtils';
import Message from '../common/message';
import RepiFooter from './repiFooter';
import NoDataComponent from '../common/noDataComponent';

import FoIcon from '../../img/icons/FyzickaOsoba';
import PoIcon from '../../img/icons/PravnickaOsoba';
import FopIcon from '../../img/icons/FyzickaOsobaPodnikatel';
import HistoryIcon from '../../img/icons/Historie';

import './repi.scss';

const POPUP_TYPES = {
    consent: "consent",
    repiGroups: "repiGroups"
};

const HIGHLIGHT_CLASS = "repi-search-highlight";

class RepiSearchResults extends React.Component {
    get isFoSearch() { return getParams(window.location.search).entityType === "fo"; }
    get repiSettings() { return JSON.parse(localStorage.getItem("auth")).repi }
    get sharingAllowed() { return getRepiSetting("allowSharing", false); }

    render() {
        if (this.props.isSearching)
            return <Circles />;
        
        if (!isNullOrUndefined(this.props.error)) {
            return (
                <div className="card" style={{ marginTop: "1em", width: "95%" }}>
                    <Message type="error" message={this.props.translate("Repi.Error.Search.SearchFailed")} />
                </div>
            );
        }

        if (isNullOrUndefined(this.props.searchResult) || isNullOrUndefined(this.props.searchResult.results)
            || this.props.searchResult.results.length === 0) {
            return (
                <div style={{ marginTop: "1em", width: "95%" }}>
                    <NoDataComponent />
                </div>
            );
        }

        return (
            <div className="repi-search-wrapper">
                <div className="search-content">
                    <div className="card">
                        <div className="card-body">
                            {this.props.searchResult.results.map((item, idx) => this.renderItem(item, idx + 1))}
                        </div>
                    </div>
                    <RepiFooter />
                </div>
            </div>
        );
    }

    componentDidMount() {
        const searchParams = this.getSearchParams();
        if (!isNullOrUndefined(searchParams))
            this.props.searchCandidates(searchParams);
    }

    renderItem = (item, idx) => {
        const Icon = item.entityType === "PO" ? PoIcon : item.entityType === "FOP" ? FopIcon : FoIcon;

        return (
            <div key={idx} className="repi-search-result">
                <div className="repi-index">{idx}.</div>
                <div className="repi-data">
                    <div className="repi-identification repi-data-row">
                        <Icon className="search-result-icon svg-standard-fill" />
                        <span style={{ marginRight: "0.3em" }}>{this.renderIdentification(item)}</span>
                        <PngFlag countryCode={item.countryName} />
                    </div>
                    {this.renderAddress(item)}
                    {this.renderHistoryMatches(item)}
                    <div>
                        <span className="report-links">
                            {this.renderReportLinks(item)}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    renderIdentification = (item) => {
        const items = [];

        if (item.entityType === "PO"|| item.entityType === "FOP" || isNullOrUndefined(item.entityType) && (!this.isFoSearch || isEmpty(item.name) && isEmpty(item.surname))) {
            const companyName = isEmpty(item.companyName) ? null : item.companyName.trim();
            const companyId = isEmpty(item.companyId) ? null : item.companyId.trim();

            if (companyName !== null)
                items.push(<span className="repi-name">{this.generateHighlightedPropery(repiSearchFields.companyName, companyName)}</span>);
            if (companyId !== null) {
                items.push(<span>
                    {this.props.translate("Repi.Search.CompanyId.Short")}: {this.generateHighlightedPropery(
                        repiSearchFields.companyId, companyId, null, repiSearchFields.companyIdFop)}
                </span>);
            }
        }

        if (item.entityType === "FO" || item.entityType === "FOP" || isNullOrUndefined(item.entityType) && this.isFoSearch) {
            const pin = isEmpty(item.pin) ? null : item.pin.trim();
            const name = isEmpty(item.name) ? null : item.name.trim();
            const surname = isEmpty(item.surname) ? null : item.surname.trim();
            const birthDateFormatted = isEmpty(item.birthDateFormatted) || !isString(item.birthDateFormatted) || item.birthDateFormatted.trim() === ""
                ? null : item.birthDateFormatted.trim();

            if (name !== null || surname !== null)
                items.push(<span className="repi-name">
                    {name === null ? null : this.generateHighlightedPropery(repiSearchFields.name, name)}
                    {surname === null ? null : <>
                        {name === null ? null : <> </>}
                        {this.generateHighlightedPropery(repiSearchFields.surname, surname)}
                    </>}
                </span>);
            if (birthDateFormatted !== null)
            items.push(this.generateHighlightedPropery(repiSearchFields.birthDate, birthDateFormatted, item.birthDate));
            if (pin !== null)
                items.push(this.generateHighlightedPropery(repiSearchFields.pin, pin));
        }

        return items.length === 0 ? null : items.reduce((acc, x) => acc === null ? x : <>{acc}&nbsp;| {x}</>, null);
    }

    renderAddress = (item) => {
        const street = isEmpty(item.street) ? null : item.street.trim();
        const houseNo = isEmpty(item.houseNumber) ? null : item.houseNumber.trim();
        const city = isEmpty(item.city) ? null : item.city.trim();
        const zip = isEmpty(item.zip) ? null : item.zip.trim();
        const items = [];

        if (street !== null || houseNo !== null) {
            items.push((<span>
                {street === null ? null : this.generateHighlightedPropery(repiSearchFields.street, street)}
                {houseNo === null ? null : <>
                    {street === null ? null : <> </>}
                    {this.generateHighlightedPropery(repiSearchFields.houseNo, houseNo)}
                </>}
            </span>));
        }

        if (city !== null)
            items.push(this.generateHighlightedPropery(repiSearchFields.city, city));
        if (zip !== null)
            items.push(this.generateHighlightedPropery(repiSearchFields.zip, zip));

        return items.length === 0 ? null :
            <div className="repi-data-row">{items.reduce((acc, x) => acc === null ? x : <>{acc}, {x}</>, null)}</div>;
    }

    renderHistoryMatches = (item) => {
        if (isNullOrUndefined(item) || isNullOrUndefined(item.historyMatch) || item.historyMatch.anyMatch !== true)
            return true;

        const historyMatches = [];
        if (!isNullOrUndefined(item.historyMatch.subject)) {
            Object.keys(item.historyMatch.subject).forEach(k => {
                if (!isNullOrUndefined(item.historyMatch.subject[k]))
                    historyMatches.push({ label: `Repi.Search.${capitalize(k)}`, value: item.historyMatch.subject[k] })
            });
        }

        if (!isNullOrUndefined(item.historyMatch.address)) {
            Object.keys(omit(item.historyMatch.address, ["countryCode"])).forEach(k => {
                if (!isNullOrUndefined(item.historyMatch.address[k]))
                    historyMatches.push({ label: `Repi.Search.${capitalize(k)}`, value: item.historyMatch.address[k] })
            });
        }

        if (!isNullOrUndefined(item.historyMatch.contact)) {
            Object.keys(item.historyMatch.contact).forEach(k => {
                if (!isNullOrUndefined(item.historyMatch.contact[k]))
                    historyMatches.push({ label: `Repi.Search.${capitalize(k)}`, value: item.historyMatch.contact[k] })
            });
        }

        return (
            <div className="repi-data-row" title={this.props.translate("Repi.Search.HistoryMatches")}>
                <HistoryIcon className="search-row-history-icon" style={{ height: '1.25em', width: '1.25em', verticalAlign: "sub" }} />
                <span className="qs-historical-names">
                    <span> </span>
                    {historyMatches.map(h => <span className="repi-history-match" key={h.label}>
                        <Translate id={h.label} />: <span className="repi-history-match-value">{h.value}</span>
                    </span>)}
                </span>
            </div>
        );
    }

    renderReportLinks = (item) => {
        const reports = getReportsAvailability();
        const settings = this.repiSettings;

        if (isNullOrUndefined(reports))
            return null;

        return (
            <>
                {reports[reportTypes.creditPlus] &&
                    this.renderReportLink(reportTypes.creditPlus, item, true, this.hasConsent(item.subjectId) ? null : POPUP_TYPES.consent)}
                {reports[reportTypes.creditMinus] && this.renderReportLink(reportTypes.creditMinus, item, true)}
                {reports[reportTypes.subjectPlus] && this.renderReportLink(reportTypes.subjectPlus, item, true)}
                {reports[reportTypes.poolPlus] && this.renderReportLink(reportTypes.poolPlus, item, true,
                    !settings.takeFirstGroup && Object.keys(settings.customerGroups).length > 0
                        ? POPUP_TYPES.repiGroups : this.hasConsent(item.subjectId) ? undefined : POPUP_TYPES.consent)}
                {reports[reportTypes.poolMinus] && this.renderReportLink(reportTypes.poolMinus, item, true,
                    !settings.takeFirstGroup && Object.keys(settings.customerGroups).length > 0 ? POPUP_TYPES.repiGroups : undefined)}
                {reports[reportTypes.invoicesPlus] && this.renderReportLink(reportTypes.invoicesPlus, item, false,
                    this.hasConsent(item.subjectId) ? null : POPUP_TYPES.consent)}
                {reports[reportTypes.invoicesMinus] && this.renderReportLink(reportTypes.invoicesMinus, item)}
                {reports[reportTypes.dataCorrection] && this.renderReportLink(reportTypes.dataCorrection, item)}
                {reports[reportTypes.dataCorrectionInternal] && this.renderReportLink(reportTypes.dataCorrectionInternal, item)}
            </>
        );
    }

    renderReportLink = (reportType, item, checkPrice = false, popupAction = null) => {
        const isDataCorerction = reportType === reportTypes.dataCorrection || reportType === reportTypes.dataCorrectionInternal;
        const isPo = (item.entityType || "").toLowerCase() === "po";
        const params = {
            sharedRegistry: this.sharingAllowed && item.sharedRegistry
        };

        if ((reportType === reportTypes.poolMinus || reportType === reportTypes.poolPlus) && popupAction !== POPUP_TYPES.repiGroups) {
            const groups = Object.keys(this.repiSettings.customerGroups);
            if (groups.length > 0)
                params.poolGroup = groups[0];
        }

        if (checkPrice || popupAction === POPUP_TYPES.consent) {
            return (
                <span key={reportType}
                    className={classnames("report-link", { "is-square": localStorage.locales_button_style === "square", "hide-on-mobile": isDataCorerction })}
                    style={{ cursor: "pointer" }}
                    onClick={() => checkPrice
                        ? this.onCheckPrice(reportType, item, params, popupAction, isPo)
                        : this.displayConsentPopup(reportType, item, params, popupAction, isPo)
                    }
                >
                    {ReactHtmlParser(this.props.translate(`Repi.Report.${capitalize(reportType)}`))}
                </span>
            );
        }

        return (
            <Link key={reportType}
                className={classnames("report-link", { "is-square": localStorage.locales_button_style === "square", "hide-on-mobile": isDataCorerction })}
                to={`/repi/report/${capitalize(reportType)}/${item.subjectId}?${new URLSearchParams(params)}`}
            >{ReactHtmlParser(this.props.translate(`Repi.Report.${capitalize(reportType)}`))}</Link>
        );
    }

    onCheckPrice = (reportType, item, params, popupAction, isPo) => {
        const reportName = capitalize(reportType);
        const isPool = isPoolReport(reportType);

        let defaultPoolGroup = null;
        if (isPool) {
            defaultPoolGroup = isPool && Object.keys(this.repiSettings.customerGroups).length > 0
                ? parseInt(Object.keys(this.repiSettings.customerGroups).sort()[0])
                : null;
            params.poolGroup = defaultPoolGroup;
        }

        params = omit(params, ["consent"]);

        apiGet(`${getHostApi()}/api/repi/report/${reportName}/${item.subjectId}/check`, params,
            s => {
                if (isNullOrUndefined(s) || !s.hasData)
                    writeErr(`/api/repi/report/${reportName}/${item.subjectId}/check -- No data returned from API`);
                else if (s.data === 0 && popupAction !== POPUP_TYPES.repiGroups)
                    this.displayConsentPopup(reportType, item, params, popupAction, isPo);
                else {
                    this.props.showPopup("repiReportCreditConfirmationPopup", {
                        title: this.props.translate('Common.Warning'),
                        open: true,
                        reportName: reportName,
                        reportType: reportType,
                        requestParams:  params,
                        price: s.data,
                        error: s.error,
                        subjectId: item.subjectId,
                        consent: isPo ? true : this.hasConsent(item.subjectId),
                        isPo: isPo,
                        close: isNullOrUndefined(s.error) ? undefined : () => this.props.hidePopup(),
                        no: () => this.props.hidePopup(),
                        yes: (consent, poolGroup) => {
                            if (consent)
                                addConsentToStorage(item.subjectId);
                            if (!isNullOrUndefined(poolGroup))
                                params.poolGroup = poolGroup;
                            const searchParams = new URLSearchParams(params);
                            this.props.repiRedirect(`/report/${capitalize(reportType)}/${item.subjectId}?${searchParams}`);
                        },
                        pool: {
                            allowSelection: popupAction === POPUP_TYPES.repiGroups,
                            groups: isPool ? this.repiSettings.customerGroups : null,
                            defaultGroup: defaultPoolGroup
                        },
                    });
                }
            },
            e => writeErr(e)
        );
    }

    displayConsentPopup = (reportType, item, params, popupAction, isPo) => {
        if (!isNullOrUndefined(popupAction) && !isPo) {
            this.props.showPopup("repiConsentPopup", {
                open: true,
                close: () => { this.props.hidePopup() },
                reportName: this.props.translate(`Repi.Report.${capitalize(reportType)}`),
                onConfirm: () => {
                    addConsentToStorage(item.subjectId);
                    const searchParams = new URLSearchParams(params);
                    this.props.repiRedirect(`/report/${capitalize(reportType)}/${item.subjectId}?${searchParams}`);
                },
            });
        } else
            this.props.repiRedirect(`/report/${capitalize(reportType)}/${item.subjectId}?${new URLSearchParams(params)}`);
    }

    getSearchParams = () => {
        const fromQuery = getParams(window.location.search);
        const searchInputs = pick(fromQuery, Object.values(repiSearchFields))
        if (Object.keys(searchInputs).length === 0)
            return null;

        const params = {};
        Object.values(repiSearchFields).forEach(k => params[k] = "");
        Object.keys(searchInputs).forEach(k => params[k] = searchInputs[k]);

        params.searchType = fromQuery.searchType === "em" ? searchTypes.exactMatch : searchTypes.fullText;
        params.entityType = fromQuery.entityType === "po" ? entityTypes.po : entityTypes.fo;
        params.consent = fromQuery.consent === "true";
        params.sharedRegistry = this.sharingAllowed && fromQuery.sharedRegistry === "true";

        return params;
    }

    generateHighlightedPropery =  (field, value, dateValue = null, altField = null) => {
        if (isNullOrUndefined(this.props.searchParams))
            return <span>{value}</span>;

        let v = this.props.searchParams[field];
        if (isNullOrUndefined(v) || isEmpty(v) || isNullOrUndefined(value) || isEmpty(value)) {
            if (!isNullOrUndefined(altField)) {
                v = this.props.searchParams[altField];
                if (isNullOrUndefined(v) || isEmpty(v) || isNullOrUndefined(value) || isEmpty(value))
                    return <span>{value}</span>;
            } else
                return <span>{value}</span>;
        }

        let match = false;
        if (!isNullOrUndefined(dateValue)) {
            try {
                const d1 = isValidDate(v) ? v : new Date(v);
                d1.setHours(0, 0, 0, 0);
                const d2 = isValidDate(dateValue) ? dateValue : new Date(dateValue);
                d2.setHours(0, 0, 0, 0);
                match = d1.getTime() === d2.getTime();
            } catch (e) {
                writeErr(e)
                match = false;
            }
            return match ? <span className={HIGHLIGHT_CLASS}>{value}</span> : <span>{value}</span>;
        } else {
            const vParam = removeDiacritics(v.toString().trim().toLowerCase(), false);
            const vResp = removeDiacritics(value.toString().toLowerCase(), false);
            if (vParam === vResp)
                return <span className={HIGHLIGHT_CLASS}>{value}</span>;
            else if (vResp.includes(vParam)) {
                const si = vResp.indexOf(vParam);
                const start = si > 0 ? value.substring(0, si) : "";
                const end = (si + vParam.length) < vResp.length ? value.substring(si + vParam.length) : "";
                return <span>{start}<span className={HIGHLIGHT_CLASS}>{value.substring(si, si + vParam.length)}</span>{end}</span>;
            } else
                return <span>{value}</span>;
        }
    }

    hasConsent = (subjectId) => this.props.consent === true || (getParams(window.location.search).consent || "").toString() === "true"
        || hasConsentInStorage(subjectId);
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.repi.search, layout: state.layout, user: state.userContext }),
    dispatch => bindActionCreators({ ...repiActions, ...layoutActions, ...popupActions }, dispatch),
)(RepiSearchResults)));
